import { getConfigAsync } from '../utils/config';

export interface AlertItem {
  user_id: string;
  alert_id: string;
  signal_id: string;
  signal_name?: string;
  symbol: string;
  timeframe: string;
  signal_type: string;
  trigger_time_ms: number;
  similarity: number;
  price?: number;
  is_read: boolean;
  created_at?: string;
  message?: string;
}

async function getApiBaseUrl(): Promise<string> {
  const config = await getConfigAsync();
  return config?.API_BASE_URL || 'https://getaws.alpha-pilot.net';
}

export async function fetchAlerts(limit: number = 50): Promise<AlertItem[]> {
  const base = await getApiBaseUrl();
  const { getApiHeadersWithoutContentType } = await import('../utils/apiHeaders');
  const resp = await fetch(`${base}/alert/list?limit=${encodeURIComponent(String(limit))}`, {
    method: 'GET',
    headers: getApiHeadersWithoutContentType(),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok || !data?.success) {
    throw new Error(data?.error || 'Failed to load alerts');
  }
  return (data.alerts || []) as AlertItem[];
}

export async function fetchUnreadCount(): Promise<number> {
  const base = await getApiBaseUrl();
  const { getApiHeadersWithoutContentType } = await import('../utils/apiHeaders');
  const resp = await fetch(`${base}/alert/unread_count`, {
    method: 'GET',
    headers: getApiHeadersWithoutContentType(),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok || !data?.success) {
    throw new Error(data?.error || 'Failed to load unread count');
  }
  return Number(data.unread_count || 0);
}

export async function markAlertRead(alert_id: string): Promise<boolean> {
  const base = await getApiBaseUrl();
  const { getApiHeaders } = await import('../utils/apiHeaders');
  const resp = await fetch(`${base}/alert/mark_read`, {
    method: 'PUT',
    headers: getApiHeaders(),
    body: JSON.stringify({ alert_id }),
  });
  const data = await resp.json().catch(() => ({}));
  return !!data?.success;
}

export async function markAllAlertsRead(): Promise<number> {
  const base = await getApiBaseUrl();
  const { getApiHeaders } = await import('../utils/apiHeaders');
  const resp = await fetch(`${base}/alert/mark_all_read`, {
    method: 'PUT',
    headers: getApiHeaders(),
    body: JSON.stringify({}),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok || !data?.success) return 0;
  return Number(data.updated || 0);
}


